import React, {useContext, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {v4 as uuidv4} from 'uuid';
import {DataContext} from '../../../../home/pages/automs/autom/FlowConfiguration';
import {updateHistory} from '../../../../helpers/historyHandler';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @param       showAlert -  show alert
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Recorder({action, variables, setOpenVariable, showAlert, recorder, setRender}) {
    const {t} = useTranslation();
    const [inputValue, setInputValue] = useState('');
    const label = 'CONTENT.CONFIGURATION-FORM.RECORDER.CAPTURE.';
    const context = useContext(DataContext);

    useEffect(() => {
        if (action.fields.file?.value) {
            setInputValue(action.fields.file.value);
        }
    }, []);

    function handleChange(event) {
        if (event.target.files[0]) {
            let reader = new FileReader();
            reader.onload = onReaderLoad;
            reader.readAsText(event.target.files[0]);
            action.fields.file = {value: event.target.files[0].name};
            setInputValue(event.target.files[0].name);
        }
    }

    function onReaderLoad(event) {
        try {
            let obj = JSON.parse(event.target.result);
            saveRecords(obj);
        } catch (error) {
            showAlert(t(label + 'INVALID'));
        }
    }

    function downloadDesktopRecorder() {
        window.open("/source/desktop_recorder.zip", '_blank').focus();
    }

    function saveRecords(data) {
        let newChildren = [];
        for (const item of data) {
            let tempAction = recorder.current.find(a => a.action_label === item.Name);
            if (tempAction) {
                let newAction = JSON.parse(JSON.stringify(tempAction));
                newAction.id = uuidv4();
                newAction.fields = {
                    value: {value: item.Value},
                    x: {value: item.X?.toString()},
                    y: {value: item.Y?.toString()}
                };
                if (item.Image) {
                    newAction.fields.image = {type: 'FILE', byteValue: item.Image, value: ''};
                }
                if (item.Locations) {
                    newAction.fields.locations = {type: 'ARRAY', value: item.Locations};
                }
                newChildren.push(newAction);
            }
        }
        action.children = newChildren;
        setRender(a => !a);
        updateHistory('flow', context.items);
    }

    return (
        <div>
            <div className="form-element">
                <button className="form-button"
                        onClick={downloadDesktopRecorder}>{t("CONTENT.LIBRARY.DESKTOP-RECORDER.DOWNLOAD")}</button>
            </div>
            <div className="form-element">
                {t(label + 'RECORD')} : &nbsp;
                <div className="custom-file config-form" style={{marginTop: 10}}>
                    <input type="file" className="custom-file-input" accept="application/JSON" id="license-customFile" onChange={handleChange}/>
                    <label className="custom-file-label" htmlFor="license-customFile">{inputValue ? inputValue : t('CONTENT.SETTINGS.GENERAL.CHOOSE')}</label>
                </div>
            </div>
        </div>
    );
}

export default Recorder;
